import { useEffect, useRef, useState } from "react";
import {
  QuestionWrapper,
  QuestionTypeChild,
  QuestionType,
  QuestionText,
  QuestionHeader,
  QuestionFooter,
  QuestionHelper,
  QuestionDescription,
} from "./Questions.style";
import EditQuestion from "./EditQuestion/Editquestion";
import QuestionOptions from "./QuestionOptions";
import EditAssessMent from "../../images/editAssessment.svg";
import Logo from "../../images/2xcell_logo.png";
import Delete from "../../images/deleteAssessment.svg";

import { htmlDecode } from "../../utils/parse";
import QuestionImage, { QuestionMedia } from "./QuestionImage";

const getText = (data) => {
  if (data === "mcq") return "Select One Option";
  else if (data === "mmcq") return "Select Multiple Correct Options";
  else if (data === "oneword") return "Answer in one word";
  else if (data === "fillup") return "Fill in the blanks";
  else if (data === "correctstatement") return "True or False";
  else if (data === "descriptive") return "HOTS Question";
  else if (data === "assertion-reasoning") return "Assertion And Reasoning";
};

function Questions(props) {
  const editRef = useRef("");
  const [edit, setEdit] = useState(false);

  function close(status) {
    editRef.current = status;
    setEdit(false);
  }

  useEffect(() => {
    if (window.MathJax && editRef.current === "cancel") {
      setTimeout(() => {
        window.MathJax.typesetPromise();
        editRef.current = "";
      }, 100);
    }
  }, [edit]);

  return (
    <>
      {edit ? (
        <EditQuestion
          handleUpdate={props?.handleUpdateQuestion}
          setEdit={setEdit}
          close={close}
          {...props}
          assessmentType={props.assessmentType}
        />
      ) : (
        <QuestionWrapper>
          <QuestionHeader>
            <QuestionText>
              {`Q${props?.no}. `}
              <span
                dangerouslySetInnerHTML={{
                  __html: htmlDecode(props.question || ""),
                }}
              />
            </QuestionText>
            <QuestionType>
              {props.assessmentType !== "competency" ? (
                <QuestionTypeChild>
                  {props?.difficulty.charAt(0).toUpperCase() +
                    props?.difficulty.slice(1)}
                </QuestionTypeChild>
              ) : null}
              {props.cognitive ? (
                <QuestionTypeChild style={{ textTransform: "capitalize" }}>
                  {props.cognitive}
                </QuestionTypeChild>
              ) : null}
            </QuestionType>
          </QuestionHeader>
          {props.questionType === "assertion-reasoning" ? (
            <>
              <QuestionDescription>
                <QuestionMedia
                  width={300}
                  height={300}
                  media={props.images?.assertImg}
                />
                <QuestionText>
                  <u>{`${props.language === "hindi"?"कथन (A):":"Assertion (A):"}`}</u>{" "}
                  <span
                    dangerouslySetInnerHTML={{
                      __html: htmlDecode(props?.description?.assertion || ""),
                    }}
                  />
                </QuestionText>
              </QuestionDescription>
              <br />
              <QuestionDescription>
                <QuestionMedia
                  width={300}
                  height={300}
                  media={props.images?.reasonImg}
                />
                <QuestionText>
                  <u>{`${props.language === "hindi"?"कारण (B):":"Reasoning (B):"}`}</u>{" "}
                  <span
                    dangerouslySetInnerHTML={{
                      __html: htmlDecode(props?.description?.reasoning || ""),
                    }}
                  />
                </QuestionText>
              </QuestionDescription>
            </>
          ) : null}

          <div style={{ marginTop: "10px" }}>
            <div className="questionContainer">
              <QuestionMedia media={props.images?.questionImg} />
              <div style={{ width: "100%" }}>
                <QuestionOptions
                  isQuestionImg={props.images?.questionImg}
                  questionType={props?.questionType}
                  options={props?.options}
                  marks={props?.marks}
                  question={props?.question}
                  visibility={props?.visibility}
                  images={props?.images}
                  difficulty={props?.difficulty}
                  answer={props?.correctAnswers[props?.questionType]}
                />
              </div>
            </div>
          </div>
          <QuestionFooter>
            <div className="firstDiv">
              <img src={Logo} alt="logo" />
            </div>
            <div className="icons">
              <img
                onClick={() => setEdit(true)}
                style={{ cursor: "pointer" }}
                src={EditAssessMent}
                alt="edit"
              />
              <img
                src={Delete}
                style={{ cursor: "pointer" }}
                onClick={() => props.handleDeleteQuestion(props.id)}
                alt="delete"
              />
              &nbsp;&nbsp;
              <span>(v1.0)</span>
            </div>
          </QuestionFooter>
          <QuestionHelper>{getText(props.questionType)}</QuestionHelper>
        </QuestionWrapper>
      )}
    </>
  );
}

export default Questions;
